import { Button, ChevronDownIcon } from '@calizahq/react-components-v2'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { LegacyDropdown } from '@/components'
import reservationQueries from '@/graphql/queries/reservation.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { ReservationDetail } from '@/types/Reservation'
import { HomeAccess } from '@/views/Home/Home/HomeAccess/HomeAccess'
import { HomeDetail } from '@/views/Home/Home/HomeDetail/HomeDetail'
import { PropertyDetail } from '@/views/Property/Property/PropertyDetail'

import { MoveInView } from './components/MoveInView/MoveInView'
import { ParkingView } from './components/ParkingView/ParkingView'
import { StatusView } from './components/StatusView/StatusView'
import { viewOptions, viewOptionValues } from './Reservation.data'

export function Reservation() {
  const { reservationId } = useParams<{ reservationId: string }>()
  const { data: reservationDetail } = useGraphql<{ reservation: ReservationDetail }>(
    'reservationDetail',
    reservationQueries.getReservation,
    { reservation: Number(reservationId) },
    {
      enabled: !!reservationId && !!Number(reservationId),
    },
  )

  const reservationData = reservationDetail?.reservation

  const navigate = useNavigate()

  const [viewValue, setViewValue] = useState<{ name: string; value: string }>(viewOptions[0])
  const [isOpen, setIsOpen] = useState(false)
  const className = ' hover:text-link-deemphasized focus-visible:text-link-deemphasized'
  const buttonClassName = 'last-of-type:pb-4 first-of-type:pt-4 px-6 py-2'
  function handleViewChange(option) {
    setViewValue(option)
    setIsOpen(false)
  }

  if (!reservationData) return <div></div>
  return (
    <div className="flex min-h-140 w-full max-w-screen-lg flex-col  p-4 md:p-8">
      <div className="flex justify-between">
        <button className="button-text m-0 p-0 text-sm underline" onClick={() => navigate(-1)}>{`< Back`}</button>
        <div
          className="rounded-full px-3 py-2 text-sm text-action-primary tag-green-light"
          onClick={() => navigate(`/members/${reservationData.member.id}`)}
          role={'presentation'}
        >
          {reservationData.member?.fullName || ''} - {reservationData.id}
        </div>
      </div>

      <div className="flex items-center py-4">
        <LegacyDropdown
          className="mr-4"
          direction="right"
          isOpen={isOpen}
          renderToggle={() => (
            <Button
              className="whitespace-nowrap  bg-action-secondary"
              renderRightIcon={() => <ChevronDownIcon className="w-4" />}
              size="small"
              variant="secondary"
            >
              {viewValue.name}
            </Button>
          )}
          setIsOpen={setIsOpen}
        >
          {viewOptions.map((option, index) => {
            return (
              <button
                className={`${className} ${buttonClassName} ${
                  option.value === viewValue.value ? 'text-text-link' : ' text-icon-secondary'
                } `}
                key={index}
                onClick={() => handleViewChange(option)}
              >
                {option.name}
              </button>
            )
          })}
        </LegacyDropdown>
      </div>

      {viewValue.value === viewOptionValues.MOVE_IN && <MoveInView reservationData={reservationData} />}
      {viewValue.value === viewOptionValues.PROPERTY && (
        <PropertyDetail propertyId={reservationData.home.property.id} />
      )}
      {viewValue.value === viewOptionValues.HOME && <HomeDetail homeId={reservationData?.home?.id} />}
      {viewValue.value === viewOptionValues.STATUS && <StatusView reservationData={reservationData} />}
      {viewValue.value === viewOptionValues.PARKING && <ParkingView reservationData={reservationData} />}
      {viewValue.value === viewOptionValues.ACCESS && <HomeAccess homeId={reservationData?.home?.id} />}
    </div>
  )
}
